<template>
	<div class="mainFrame">
		<div class="headerBox">
			<myHeader></myHeader>
		</div>
		<div class="leftMemuBox">
			<myLeft></myLeft>
		</div>
		<div class="mainBox" :class="{testBg:environmental=='test',devBg:environmental=='dev'}">
			<!-- <keep-alive>
				<router-view/>
			</keep-alive> -->
			<router-view/>

		</div>
		<!-- <div class="footerBox">
			<myFooter></myFooter>
		</div> -->

	</div>
</template>

<script>
	import myHeader from '@/components/headerComponent.vue'
	import myLeft from '@/components/leftComponent.vue'
	import myFooter from '@/components/footerComponent.vue'
	import { utils } from '@/common/common.js'
	export default {
		name: 'mainFrame',
		data() {
			return {
				msg: 'Welcome to Your Vue.js App',
                environmental:'',

			}
		},
		components: {
			myHeader,
			myLeft,
			myFooter
		},
		computed: {},
		methods: {

		},
		mounted() {
            this.environmental=utils.getCurrentApi()
            // alert(this.environmental)
            
        }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	
	* {
		// outline: 1px solid red;
	}
    .mainBox.testBg{background:url('../assets/images/pic/shuiyin-test.png') ;}
    .mainBox.devBg{background:url('../assets/images/pic/shuiyin-dev.png') ;}
	.mainBox{ min-width: 1140px;
    }
	.mainFrame {
		.headerBox {
			background: $darkestColor;
		}

		.leftMemuBox {
			position: absolute;
			top: 1.25rem;
			width: 5rem;
			left: 0;
			bottom: 0;
			background: $darkestColor;
			color:$whiteColor;
		}

		.mainBox {
			position: absolute;
			top: 1.25rem;
			left: 5.0rem;
			right: 0;
			bottom: 0rem;
			overflow: auto;
		}

		.footerBox {
			position: absolute;
			bottom: 0;
			left: 5.25rem;
			right: 0;
			background: $whiteColor;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/mainFrame.vue